import { merge, map, cloneDeep } from 'lodash'
import { http, queryString } from 'utils'
import { Roles } from 'utils/user'

// Carrier mutation imports.
import { SET_CARRIERS, PUSH_CARRIER } from 'vx/mutations'

// Carrier state.
const state = {
  carriers: []
}

// Carrier state getters.
const getters = {
  /**
   * Carriers as selectize options.
   */
  carrierOptions: state => map(cloneDeep(state.carriers), carrier => ({ id: carrier.id, text: carrier.profile.company_name }))
}

// Carrier actions.
const actions = {
  /**
   * Get all carriers.
   */
  getCarriers ({ commit }, payload) {
    let defaultPayload = {
      master: true,
      roles: [Roles.CARRIER],
      include: ['trucks', 'drivers']
    }

    return http.get(`users?${queryString(merge(defaultPayload, payload))}`).then(response => {
      commit(SET_CARRIERS, response.data.data)

      return state.carriers
    })
  }
}

// Carrier state mutations.
const mutations = {
  /**
   * Set the carriers.
   */
  [SET_CARRIERS] (state, carriers) {
    state.carriers = carriers
  },

  /**
   * Add a carrier.
   */
  [PUSH_CARRIER] (state, carrier) {
    state.carriers.push(carrier)
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/carrier.js